import React from 'react';

/**
 * Compact card action that opens the cross-source context of an item in the
 * side inspector. Styled to blend with provider card meta rows.
 */
export const ViewContextButton: React.FC<{
  onClick: (e: React.MouseEvent) => void;
  label?: string;
}> = ({ onClick, label = 'Ver contexto' }) => (
  <button
    type="button"
    data-testid="view-context-button"
    onClick={onClick}
    title="Ver el contexto de este item en la barra lateral"
    aria-label={label}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 5,
      height: 28,
      padding: '0 10px',
      borderRadius: 9,
      border: '1px solid var(--z-border)',
      background: 'var(--z-surface)',
      color: 'var(--z-muted-2)',
      fontSize: 11.5,
      fontWeight: 600,
      cursor: 'pointer',
    }}
  >
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M6.34 17.66l2.83-2.83M14.83 9.17l2.83-2.83" />
      <circle cx="12" cy="12" r="2.5" />
    </svg>
    {label}
  </button>
);